<template>
  <div>
    <div class="page-head"><div><h1>课程排期</h1><p>创建课程并管理老师、时间和名额</p></div><el-button type="primary" icon="el-icon-plus" @click="open()">新增课程</el-button></div>
    <div class="panel">
      <div class="filters">
        <span>显示课程</span>
        <el-radio-group v-model="statusFilter" size="small">
          <el-radio-button label="active">开放中</el-radio-button>
          <el-radio-button label="cancelled">已取消</el-radio-button>
          <el-radio-button label="all">全部</el-radio-button>
        </el-radio-group>
      </div>
      <el-table :data="filteredRows" v-loading="loading" style="width:100%">
        <el-table-column prop="start_at" label="上课时间" width="180" />
        <el-table-column label="课程" min-width="220"><template slot-scope="{row}"><div class="course-cell"><strong>{{ row.headline || row.title }}</strong><span>{{ row.title }}</span></div></template></el-table-column>
        <el-table-column prop="teacher" label="老师" width="110"><template slot-scope="{row}">{{ row.teacher || '—' }}</template></el-table-column>
        <el-table-column label="难度" width="145"><template slot-scope="{row}"><span class="difficulty">{{ starText(row.difficulty) }}</span></template></el-table-column>
        <el-table-column label="扣除时长" width="105"><template slot-scope="{row}">{{ row.duration_min }} 分钟</template></el-table-column>
        <el-table-column label="预约人数" width="105"><template slot-scope="{row}">{{ row.booked_count }} / {{ row.capacity }}</template></el-table-column>
        <el-table-column label="开班条件" width="168"><template slot-scope="{row}"><div class="opening-rule" :class="row.booked_count >= row.min_participants ? 'opening-ready' : 'opening-pending'"><strong>{{ row.booked_count }} / {{ row.min_participants }} 人成班</strong><span>{{ row.booked_count >= row.min_participants ? '已满足开班条件' : '还差 ' + (row.min_participants - row.booked_count) + ' 人' }}</span></div></template></el-table-column>
        <el-table-column label="状态" width="110"><template slot-scope="{row}"><el-tag :type="row.status === 'active' ? 'success' : 'info'" size="small">{{ row.status === 'active' ? '开放中' : '已取消' }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="235"><template slot-scope="{row}">
          <el-button size="mini" @click="$router.push({path:'/bookings',query:{classId:row.id}})">名单</el-button>
          <el-button v-if="row.status === 'active'" size="mini" @click="open(row)">编辑</el-button>
          <el-button v-if="row.status === 'active'" size="mini" type="danger" plain @click="remove(row)">取消</el-button>
        </template></el-table-column>
      </el-table>
    </div>
    <el-dialog :title="form.id ? '编辑课程' : '新增课程'" :visible.sync="visible" width="500px">
      <el-form :model="form" label-width="88px">
        <el-form-item label="课程标题" required><el-input v-model.trim="form.headline" maxlength="60" show-word-limit placeholder="例如：成人零基础芭蕾" /></el-form-item>
        <el-form-item label="课程内容" required><el-input v-model.trim="form.title" type="textarea" :rows="2" maxlength="120" show-word-limit placeholder="例如：零基础芭蕾，练习基础站姿与把杆动作" /></el-form-item>
        <el-form-item label="上课时间"><el-date-picker v-model="form.start_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="width:100%" /></el-form-item>
        <el-form-item label="授课老师" :required="!form.id"><el-input v-model.trim="form.teacher" :placeholder="form.id ? '请输入授课老师' : '请输入授课老师（必填）'" maxlength="80" /></el-form-item>
        <el-form-item label="课程难度"><el-rate v-model="form.difficulty" :max="5" show-text :texts="['一星','二星','三星','四星','五星']" /></el-form-item>
        <el-form-item label="上课/扣除时长"><el-input-number v-model="form.duration_min" :min="30" :max="240" :step="30" /> 分钟</el-form-item>
        <el-form-item label="人数上限"><el-input-number v-model="form.capacity" :min="1" :max="100" /></el-form-item>
        <el-form-item label="开班下限"><el-input-number v-model="form.min_participants" :min="1" :max="form.capacity || 1" /> 人<div class="form-hint">开课时未满下限将自动取消</div></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import { listClasses, createClass, updateClass, cancelClass } from '../api'
const blank = () => ({ headline: '', title: '', start_at: '', teacher: '', difficulty: 1, duration_min: 90, capacity: 12, min_participants: 5 })
export default {
  data: () => ({ rows: [], statusFilter: 'active', loading: false, saving: false, visible: false, form: blank() }),
  computed: {
    filteredRows () {
      const rows = this.statusFilter === 'all'
        ? this.rows
        : this.rows.filter(row => row.status === this.statusFilter)
      const now = Date.now()
      const group = row => {
        if (row.status !== 'active') return 2
        return new Date(row.start_at.replace(/-/g, '/')).getTime() >= now ? 0 : 1
      }
      return rows.slice().sort((a, b) => {
        const groupDiff = group(a) - group(b)
        if (groupDiff) return groupDiff
        return group(a) === 0 ? a.start_at.localeCompare(b.start_at) : b.start_at.localeCompare(a.start_at)
      })
    }
  },
  created () { this.load() },
  methods: {
    async load () { this.loading = true; try { this.rows = await listClasses() } catch (e) { this.$message.error(e.message) } finally { this.loading = false } },
    open (row) { this.form = row ? { ...row, headline: row.headline || row.title } : blank(); this.visible = true },
    async save () {
      if (!this.form.headline || !this.form.title || !this.form.start_at) return this.$message.warning('请填写课程标题、课程内容和上课时间')
      if (!this.form.id && !this.form.teacher.trim()) return this.$message.warning('请填写授课老师')
      if (Number(this.form.min_participants) > Number(this.form.capacity)) return this.$message.warning('开班下限不能超过人数上限')
      this.saving = true
      try {
        if (this.form.id) await updateClass(this.form.id, this.form)
        else await createClass(this.form)
        this.visible = false; this.$message.success('保存成功'); this.load()
      } catch (e) { this.$message.error(e.message) } finally { this.saving = false }
    },
    starText (difficulty) { return '⭐️'.repeat(Math.max(1, Math.min(5, Number(difficulty) || 1))) },
    async remove (row) {
      try {
        await this.$confirm('取消课程前，需先处理所有有效预约。确定继续？', '确认取消', { type: 'warning' })
        await cancelClass(row.id); this.$message.success('课程已取消'); this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message) }
    }
  }
}
</script>
<style scoped>
.filters { display: flex; align-items: center; gap: 14px; margin: -2px 0 18px; color: #68726e; font-size: 13px; }
.difficulty { color: #c89436; letter-spacing: 1px; }
.course-cell { display: flex; flex-direction: column; gap: 5px; line-height: 1.35; }
.course-cell strong { color: #304348; font-size: 14px; }
.course-cell span { color: #84908a; font-size: 12px; }
.form-hint { color: #8a958d; font-size: 12px; line-height: 1.5; margin-top: 8px; }
.opening-rule { display: flex; flex-direction: column; gap: 4px; font-size: 12px; line-height: 1.3; }
.opening-rule strong { font-size: 13px; }
.opening-rule span { color: #8a958d; }
.opening-ready strong { color: #527865; }
.opening-pending strong { color: #c07b2d; }
</style>
